<div class="navigation" matRipple>
  <mat-icon>chevron_left</mat-icon>&nbsp; <h3>{{title}}</h3>
</div>